import React from "react";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const isLoggedIn = !!user;

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col font-[Inter]">
      {/* Header / Navbar */}
      <header className="bg-[#FF4D00] text-white shadow-lg sticky top-0 z-50 transition-all duration-300">
        <div className="container mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center md:items-center">
          <h1 className="text-2xl font-bold text-center md:text-left mb-2 md:mb-0">
            Governance & Continuity Maturity Assessment Tool
          </h1>

          <nav className="flex flex-col md:flex-row items-center gap-3 md:gap-4 text-sm md:text-base">
            <Link to="/" className="hover:underline transition hover:text-orange-100">Home</Link>
            <Link to="/features" className="hover:underline transition hover:text-orange-100">Features</Link>
            <Link to="/about" className="hover:underline transition hover:text-orange-100">About</Link>
            <Link to="/contact" className="hover:underline transition hover:text-orange-100">Contact</Link>

            {isLoggedIn && user?.frameworks?.includes("COBIT") && (
              <Link
                to="/cobit/dashboard"
                className="hover:underline transition hover:text-orange-100"
              >
                COBIT Dashboard
              </Link>
            )}

            {isLoggedIn && user?.frameworks?.includes("BCM") && (
              <Link
                to="/bcm/dashboard"
                className="hover:underline transition hover:text-orange-100"
              >
                BCM Dashboard
              </Link>
            )}

            {/* Only show Logout if logged in */}
            {isLoggedIn && (
              <button
                onClick={handleLogout}
                className="bg-white text-[#FF4D00] px-4 py-2 rounded-full hover:bg-orange-100 transition transform hover:scale-105"
              >
                Logout
              </button>
            )}
          </nav>
        </div>
      </header>

      {/* Dynamic content */}
      <main className="flex-grow bg-gray-50">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-10 mt-12">
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-2">About</h4>
            <p className="text-gray-400 text-sm">
              Governance & Continuity Maturity Assessment Tool helps organizations evaluate IT governance & business continuity.
            </p>
          </div>
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-2">Website</h4>
            <a
              href="https://www.izingcweti.co.za"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF4D00] hover:underline transition"
            >
              www.izingcweti.co.za
            </a>
            <p className="text-gray-400 text-sm">Izingcweti ICT Solutions</p>
          </div>
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-2">Contact</h4>
            <p className="text-gray-400 text-sm">Email: info@izingcweti.co.za</p>
            <p className="text-gray-400 text-sm">Phone: +27 (0)31 109 6662 / +27 (0)84 310 1221</p>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Governance & Continuity Maturity Assessment Tool. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Layout;
